import { Component, ViewChild, OnInit, HostBinding } from '@angular/core';
import { Nav, Platform, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AngularFireAuth } from 'angularfire2/auth';
import { OneSignal } from '@ionic-native/onesignal';
import { oneSignalConfig } from './settings.config';
import { DatabaseServiceProvider } from '../providers/database-service/database-service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  templateUrl: 'app.html',
  selector: 'MyApp',
  providers: [StatusBar, SplashScreen, OneSignal]
})
export class MyApp implements OnInit {
  Cart: any = [];
  noOfItemsInCart: any;
  noOfItemsInFevrt: any;
  noOfItemsInNews: any;
  noOfItemsInOffer: any;
  userID: any;
  name: any;

  @ViewChild(Nav) nav: Nav;

  rootPage: string = "SearchPage";
  user: any = {}
  isDesktop: boolean = false;
  storeSelected: boolean = false;
  businessInfo: any;

  constructor(public af: AngularFireAuth,
    public platform: Platform,
    public statusbar: StatusBar,
    public splashscreen: SplashScreen,
    public events: Events,
    private oneSignal: OneSignal,
    private _sanitizer: DomSanitizer,
    private afService: DatabaseServiceProvider,) {
    this.initializeApp();
    this.Cart = JSON.parse(localStorage.getItem('Cart'));
    if (localStorage.getItem('Cart') != null) {
      this.noOfItemsInCart = this.Cart.length;
    }
    this.user.imageUrl = '';

  }

  openPage(page) {
    this.nav.setRoot(page.component);
  }

  initializeApp() {
    //cliend Id
    var _clientId = localStorage.getItem('clientId');
    if (typeof _clientId === 'undefined') {
      this.storeSelected = false;
    } else {
      this.storeSelected = true;
    }
    // Set your iOS Settings
    var iosSettings = {
      kOSSettingsKeyAutoPrompt: true,
      kOSSettingsKeyInAppLaunchURL: false
    }
    if (this.platform.ready()) {
      this.platform.ready().then((res) => {
        if (res == 'cordova') {
          this.oneSignal.startInit(oneSignalConfig.appId, oneSignalConfig.googleProjectNumber);
          this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert); //InAppAlert
          // var platformId = this.oneSignal.getIds();
          this.oneSignal.iOSSettings(iosSettings);
          this.oneSignal.handleNotificationReceived().subscribe(() => {
          });
          this.oneSignal.handleNotificationOpened().subscribe(() => {
          });
          this.oneSignal.endInit();
        }
      });
    }
    //Check if running on desktop
    if (this.platform.is('core')) {
      // This will only print when on desktop
      this.isDesktop = true;
      console.log("%cSTOP! %cThis browser feature is intended for developers only.", "color: red; font-size:45px;", "color: blue; font-size:20px;");
      // console.log("%cSo, close this console and focus on ordering your food, do it now and we will get it in time for your movie!", "color: green; font-size:20px;");
    }

  }

  home() {
    this.nav.setRoot("HomePage");
  }

  yourOrders() {
    this.nav.setRoot("OrdersPage");
  }

  addToCart() {
    this.nav.setRoot("CartPage");
  }

  catagory() {
    this.nav.setRoot("CategoryPage");
  }

  favourite() {
    this.nav.setRoot("FavouritePage");
  }

  news() {
    this.nav.setRoot("NewsPage");
  }

  contact() {
    this.nav.setRoot("ContactPage");
  }

  aboutUs() {
    this.nav.setRoot("AboutUsPage");
    // this.nav.setRoot("FinixCardNewPage");
  }

  settings() {
    this.nav.setRoot("Settings");
  }

  login() {
    this.nav.setRoot("LoginPage",
      {
        navFrom: "menu"
      }
    );
  }


  updatePassword() {
    this.nav.setRoot("UpdatePasswordPage");
  }

  logout() {
    this.af.auth.signOut().then(res => {
      var _clientId = localStorage.getItem('clientId')
      localStorage.clear();
      if(_clientId){ localStorage.setItem('clientId', _clientId); }
      this.nav.setRoot("LoginPage");
    });
  }

  isLoggedin() {
    return localStorage.getItem('uid') != null;
  }
  selectCity() {
    this.nav.setRoot("SelectCityPage",
      {
        navFrom: "menu"
      }
    );
  }

  getClientData() {
    this.events.subscribe('locChange', data => {
      // console.log(data)
      //Get user preferences
      this.af.authState.subscribe(user => {
        if (user) {
          this.userID = this.af.auth.currentUser.uid;
          this.afService.getItemObject('users/' + this.userID).take(1).subscribe(res => {
            // this.user = res;
            // console.log(res)
            if (typeof res == 'undefined') {
              this.name = '';
              this.user.imageUrl = '';
            } else {
              this.name = (res as any).name || '';
              this.user.imageUrl = (res as any).imageUrl || '';
            }
            //console.log(this.user.imageUrl);
          });
          this.afService.getItemList('users/' + this.userID + '/favourite').take(1).subscribe(res => {
            if (typeof res == 'undefined') {
              this.noOfItemsInFevrt = 0
            } else {
              this.noOfItemsInFevrt = res.length;
            }
          })
        }
      })
      //offer
      this.afService.getItemList('menuItems', ref => ref.where('offer', '==', true)).take(1).subscribe(data => {
        var queriedItems = data.filter(c => c.enableCategory != false && c.posOnly != true);
        if (localStorage.getItem('selectedCity')) { queriedItems = queriedItems.filter(m => m.locationId.includes(localStorage.getItem('selectedCity'))); }
        this.noOfItemsInOffer = queriedItems.length;
      });
      //apply theme variables for the location
      this.afService.getItemList('business').take(1).subscribe((res) => {
        // this.businessInfo = res as any;
        // console.log(res)
        res.forEach(element => {
          if(element.key == 'theme'){
            this.businessInfo = element;
            //apply browser theme color
            var _businessInfo = (this.businessInfo as any)
            if(_businessInfo && _businessInfo.primary){
            var _colors = _businessInfo.primary.colors;
              var keywords;
              keywords = document.createElement('meta');
              keywords.name = "theme-color";
              keywords.content = _colors.primary || '';
            }
            //------
          }
        });
      })
    })
  }
  ngOnInit() {
    this.getClientData();
    if (localStorage.getItem('clientId')) {
      this.events.publish('locChange', Date.now())
    }
    this.transcribeUserData();
  }

  transcribeUserData(){
    this.af.authState.subscribe(user => {
      if (user) {
        this.userID = this.af.auth.currentUser.uid;
        this.afService.getItemObject('users/' + this.userID).take(1).subscribe(res => {
          if (typeof res == 'undefined') {
            this.afService.getRootDoc('users/' + this.userID).take(1).subscribe(usr => {
              if(typeof usr !== 'undefined'){ //user dosent exist in central collection
                this.name = (usr as any).name || '';
                this.user.imageUrl = (usr as any).imageUrl || '';
                var _clientId = (usr as any).clientId || [];
                usr['loyalityPoint'] = 0
                this.afService.set('users/' + this.userID, usr).then(res => {
                var _cid = localStorage.getItem('clientId');
                if(_cid){
                  _clientId.push(_cid)
                  this.afService.updateRootUserInfo(this.userID, { clientId: _clientId })
                }
              }).catch(err => console.log('unable to update user data, please logout and retry!'))
              }
            }, err =>  {   console.log(err); })
          }
        });
      }
    });
  }


  @HostBinding("attr.style")
  public get getvalueAsStyle(): any {
    // console.log(this.businessInfo)
    // return this._sanitizer.bypassSecurityTrustStyle(`--primary: green`);
    if(typeof this.businessInfo !== 'undefined'){
      var _colors = (this.businessInfo as any).primary.colors;
      var _images = this.businessInfo.primary.images;
      var _var = "--primary: '#f47d20'";
      if (_colors && _colors.primary) { _var = '--primary: ' + _colors.primary + ';' }
      if (_colors && _colors.secondary) { _var = _var + ' --secondary: ' + _colors.secondary + ';' }
      if (_colors && _colors.hover) { _var = _var + ' --hover: ' + _colors.hover + ';' }
      if (_colors && _colors.menuTextbkg) { _var = _var + ' --menuTextbkg: ' + _colors.menuTextbkg + ';' }
      if(_images && _images.menuBkgurl) { document.getElementById('sidebar-menu').style.background = "url(" + _images.menuBkgurl + ")"}
      // if(_images && _images.bg) { _var = _var + ' --bg: ' + _images.bg + ';'}
      // if(_images && _images.bg2) { _var = _var + ' --bg2: ' + _images.bg2 + ';'}
      // if(_images && _images.bg3) { _var = _var + ' --bg3: ' + _images.bg3 + ';'}
      return this._sanitizer.bypassSecurityTrustStyle(_var);
    } else {
      return
    }
  }
  ionViewCanLeave() {
    // alert('Are you sure you want to exit?');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts